let threshold = 960;
export const mobileCheckMixin = {

    data: () => {
        return {
            isOnMobileDevice : false,
            isOnTabletOrDesktop : false
        }

    },

    beforeDestroy () {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.onResize, { passive: true })
        }
    },
    mounted () {
        this.onResize()
        window.addEventListener('resize', this.onResize, { passive: true })
    },

    methods: {
        onResize () {
            this.isOnMobileDevice = window.innerWidth < threshold;
            this.isOnTabletOrDesktop = window.innerWidth > threshold;
        },
    }
}